(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('ServiceTimeSessionServantSearch', ServiceTimeSessionServantSearch);

    ServiceTimeSessionServantSearch.$inject = ['$resource'];

    function ServiceTimeSessionServantSearch($resource) {
        var resourceUrl = 'api/_search/service-time-session-servants/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
